export const defaultMapDetails = {
  zoom: 10,
  center: {
    lat: 40.7521504,
    lng: -73.98412780000001,
  },
};
